import React from 'react';
import './chat.css';

/*
 * One message row. `variant` picks the bubble surface: 'mine' | 'ai' | 'peer'.
 * `showMeta` marks the first message of a consecutive run — it renders the
 * avatar and sender label; later messages in the run keep a spacer so the
 * bubbles stay aligned.
 */
const MessageBubble = ({ variant, showMeta, senderLabel, senderIcon, time, pending, children }) => {
    const mine = variant === 'mine';

    return (
        <div className={`wt-msg ${mine ? 'wt-msg--mine' : 'wt-msg--theirs'}${showMeta ? '' : ' wt-msg--run'}`}>
            {!mine && (
                <div className="wt-msg-gutter">
                    {showMeta && (
                        <div className={`wt-avatar wt-avatar--${variant}`} aria-hidden="true">
                            {senderIcon || (senderLabel ? senderLabel.charAt(0).toUpperCase() : '?')}
                        </div>
                    )}
                </div>
            )}
            <div className="wt-msg-stack">
                {!mine && showMeta && senderLabel && (
                    <div className="wt-msg-sender">{senderLabel}</div>
                )}
                <div className={`wt-bubble wt-bubble--${variant}${pending ? ' wt-bubble--pending' : ''}`}>
                    <div className="wt-bubble-body">{children}</div>
                    <span className="wt-bubble-time">{pending ? 'Sending…' : time}</span>
                </div>
            </div>
        </div>
    );
};

export default MessageBubble;
